export const meta = {
  id: 'quick-heap-hybrid',
  name: 'Quick Sort + Heap Sort Hybrid',
  category: 'Hybrid',
  complexity: {
    time: 'O(n log n)',
    space: 'O(log n)'
  },
  description: 'Hybrid sorting algorithm combining Quick Sort with Heap Sort fallback to guarantee O(n log n) worst-case performance.'
};
